<!--
  --
  -- メールアドレス設定 ページ
  --
  -->
<template>
  <c-container form>
    <c-email-group
      @verified="onVerified"
    >
      <!-- タイトル -->
      <template #title>メールアドレスを変更</template>

      <!-- Email の説明文 -->
      <template #email-note>
        <p class="text--primary">
          ログインメールアドレスを、現在の <code class="text--primary">{{account.email}}</code> から変更します。<br>
          新しいログインメールアドレスを入力して、確認コードを送信して下さい。<br>
        </p>
        <p class="text--secondary">
          確認コードを記したメールが届かない場合、迷惑メールフィルタでブロックされている可能性があります。<br>
          迷惑メールフィルタの設定をご確認ください。<br>
          また、旧キャリアメール等で受信できない場合があります。<br>
          その場合は、Gmail等他のメールアドレスをご利用ください。<br>
          ※「docomo」「ezweb」「vodafone」
        </p>
      </template>

      <!-- Verify の説明文 -->
      <template #verify-note>
        <p class="text--primary">
          確認メールを送信しました。<br>
          メールに記載されている【確認コード】を入力して下さい。
        </p>
        <p class="text--secondary">
          メールが送信されるまでに最大5分程度かかる場合があります。<br>
          しばらく経ってもリセットメールが届かない場合は、メールアドレスを確認の上、再度メールを送信して下さい。
        </p>
      </template>
    </c-email-group>

    <c-conflict-dialog v-model="showConflictDialog"/>
  </c-container>
</template>

<script>
import page from '@/mixins/page'
import CEmailGroup from '@/pages/register/Email/CEmailGroup'
import CConflictDialog from './CConflictDialog'

import * as api from '@/api'
import * as http from '@/libs/http'
import { run } from '@/libs/a'

export default {
  name: 'Email',
  mixins: [
    page('メールアドレスを設定')
  ],
  components: {
    CEmailGroup,
    CConflictDialog
  },

  /**
   * データ取得
   */
  async prepare (to, from, store) {
    // ログイン中のユーザID を取得する
    const userID = store.getters['user/id']
    if (!userID) {
      throw new Error('The user is not logged in.')
    }

    // アカウント情報を取得する
    const resp = await api.getUserAccount(userID)

    return {
      userID: resp.data.id,
      account: resp.data.account
    }
  },

  props: {
    userID: Number,
    account: Object
  },

  data: () => ({
    showConflictDialog: false
  }),

  computed: {
    // メール送信ドメイン
    hostname () {
      return this.getters['org/emailDomain']
    }
  },

  methods: {
    /**
     * メールアドレスが認証された
     *
     * @param {String} email 認証されたメールアドレス
     * @param {Function} failed エラー時に呼び出すコールバック関数
     */
    onVerified (email, failed) {
      run(async () => {
        const resp = await api.putUserAccount(this.userID, {
          account: {
            email
          }
        })

        if (resp.status !== http.OK) {
          this.showConflictDialog = true
          return
        }

        // 1つ前のページに戻る
        this.back()
      })
    }
  }
}
</script>
